import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { ManageEventForm } from "@/features/events/components/manage-event.form";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";

function CreateEventPage() {
  return (
    <div>
      <Button variant="ghost" asChild className="mb-6 self-start">
        <Link to="/events/discover">
          <ArrowLeft className="mr-2 size-4" aria-hidden="true" />
          Return to Events
        </Link>
      </Button>
      <OnboardingHeader title="Create Event" />

      <div className="gap-4 space-y-4 md:grid md:grid-cols-12 md:space-y-0">
        <div className="col-span-7 flex flex-col space-y-4">
          <ManageEventForm />
        </div>
      </div>
    </div>
  );
}

export default CreateEventPage;
